import { N as f } from "../chunks/NcAppNavigationItem-CzK_gg7C.mjs";
export {
  f as default
};
